import React from 'react'

export default function SignoutButton(props){
	return(
		<button className={"header-button red"} onClick={props.logout}>Sign Out</button>
	)
}